import { STORE_NAME_KEY } from '@esentai/core/features/reconciliationArchive/consts/keys';
import { annotations } from '@esentai/core/features/reconciliationArchive/serializer';
import { ascending } from '@esentai/core/query-dsl';
import { sort } from '@esentai/core/serializers/params';

import { createPageSerializer } from '@/serializers';

export default createPageSerializer({
  ...annotations,

  sort: sort({
    defaultValue: ascending(STORE_NAME_KEY),
  }),
});
